/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttributeGroupingData } from '../../models/attribute-grouping-data';

export interface GetAttributesGroupingData$Params {
  orid?: number;
  attributeNames?: Array<string> | null;
}

export function getAttributesGroupingData(http: HttpClient, rootUrl: string, params?: GetAttributesGroupingData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AttributeGroupingData>>> {
  const rb = new RequestBuilder(rootUrl, getAttributesGroupingData.PATH, 'get');
  if (params) {
    rb.query('orid', params.orid, {});
    rb.query('attributeNames', params.attributeNames, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AttributeGroupingData>>;
    })
  );
}

getAttributesGroupingData.PATH = '/api/MetaModel/getAttributeGroupingData';
